import React, { useState } from "react";

import {
  Box,
  Flex,
  Link,
  Spinner,
  Text,
  useDisclosure,
} from "@chakra-ui/react";

import { Link as ReactLink, useHistory } from "react-router-dom";
import { TableRelatorioPendencia } from "../../../components/TableRelatorioPendencia";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { RiFileExcel2Line } from "react-icons/ri";
import { format } from "date-fns";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { FiltersRelatorioPendencia } from "../../../components/FiltersRelatorioPendencia";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import { ReactComponent as Relatorio } from "../../../../assets/images/relatorio.svg";
import { handleVerifyRedirectPendenciaServico } from "../../../utils/handleVerifyRedirectPendenciaServico";
import {
  servicoAcolhimentoFunc,
  criancaFunc,
  dashboardFunc,
} from "../../../../helpers/Funcionalidades";
import { handleVerifyRedirectPendencia } from "../../../utils/hadleVerifyRedirectPendencia";
import Swal from "sweetalert2";
import RelatorioService from "../../../../main/services/RelatorioService";
import SemRegistros from "../../../components/SemRegistros";
import { formatDateToISOWithNow } from "../../../utils/formatDateToISOWithNow";

export const RelatoriosPendencias = () => {
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();
  const history = useHistory();
  const hoje = new Date();
  const dataFormatada = format(hoje, "dd/MM/yyyy HH:mm");
  const dataFormatadaDate = format(hoje, "dd/MM/yyyy");
  const [tipoRelatorio, setTipoRelatorio] = useState("");

  const {
    isOpen: isOpenNovoAcolhimento,
    onOpen: onOpenNovoAcolhimento,
    onClose: onCloseNovoAcolhimento,
  } = useDisclosure();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const storage = JSON.parse(
    sessionStorage.getItem("relatorio-pendencia-filter"),
  );

  const columnsServico = [
    {
      Header: "Municipio",
      accessor: "nomeMunicipio",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Promotoria",
      accessor: "nomePromotoria",

      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "nomeServicoAcolhimento",
      Cell: (props) => {
        const id = props.row.original.idServicoAcolhimento;
        return (
          <>
            {roleKeycloack &&
            roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
              <Link
                wordBreak={"break-all"}
                title={props.value}
                as={ReactLink}
                to={"/servico-acolhimento/" + id}
              >
                <Text minWidth="250px">{props.value}</Text>
              </Link>
            ) : (
              <Text minWidth="250px">{props.value}</Text>
            )}
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Telefone",
      accessor: "telefone",
      Cell: (props) => {
        const tels = props.value;

        if (!tels) {
          return (
            <span style={{ whiteSpace: "nowrap" }}>
              {"Não possui telefone"}
            </span>
          );
        }

        return <span style={{ whiteSpace: "nowrap" }}>{tels}</span>;
      },
    },
    {
      Header: "Pendências",
      accessor: "descricaoTipoPendencia",
      Cell: (props) => {
        const pendencia = props?.value;
        const idAba = props?.row?.original?.idAba;
        const idTipoPendencia = props?.row?.original?.idTipoPendencia;
        const idServico = props?.row?.original?.idServicoAcolhimento;
        return (
          <Link
            onClick={() => {
              handleVerifyRedirectPendenciaServico(
                idAba,
                idTipoPendencia,
                history,
                idServico,
                true,
                roleKeycloack,
                user,
                idPJ,
              );
            }}
          >
            {pendencia ? pendencia : ""}
          </Link>
        );
      },
    },
    {
      Header: "Aba",
      accessor: "nomeAba",
      Cell: (props) => {
        const nomeAba = props?.value;

        return <span>{nomeAba ? nomeAba : ""}</span>;
      },
    },
  ];

  const columns = [
    {
      Header: "Municipio",
      accessor: "nomeMunicipio",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Promotoria",
      accessor: "nomePromotoria",

      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimento",
      sortType: (rowA, rowB, id, desc) => {
        const nomeServicoA = rowA?.original?.servicoAcolhimento
          ? rowA.original.servicoAcolhimento.nomeFantasia
          : "";
        const nomeServicoB = rowB?.original?.servicoAcolhimento
          ? rowB.original.servicoAcolhimento.nomeFantasia
          : "";
        return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
      },
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimento?.idPessoaJuridica,
            ));
        let temRiscoVida = false;

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        if (
          (props?.row?.original?.movimentacoes[0]?.riscoVidaMotivoSituacao ===
            "S" &&
            !permissaoServico) ||
          (!permissaoServico &&
            (props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 6) &&
            temRiscoVida)
        ) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.servicoAcolhimento?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={
                      props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""
                    }
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text>
                      {" "}
                      {props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""}
                    </Text>
                  </Link>
                ) : (
                  <Text>
                    {props.value
                      ? props.value.nomeFantasia +
                        `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                      : ""}
                  </Text>
                )}
              </>
            );
          }
        }
      },
    },
    {
      Header: "Nome da Criança",
      accessor: "nomeCrianca",
      Cell: (props) => {
        const id = props?.row?.original?.idCrianca;
        let name = props?.row?.original?.nomeCrianca;
        let ultimaMovimentacao = props?.row?.original?.movimentacoes[0];

        let temRiscoVida = false;
        let ultimaMovimentacaoRisco;

        if (ultimaMovimentacao?.idMovimento !== 2) {
          ultimaMovimentacaoRisco = props?.row?.original?.movimentacoes[0];
        }

        if (props?.row?.original?.nomeSocial) {
          name = name + " / " + props.row.original.nomeSocial;
        }

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        return (roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizar)) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM,
          ) ? (
          (ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao === "N" ||
            !ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao) &&
          !temRiscoVida ? (
            <Link
              wordBreak={"break-all"}
              title={name}
              as={ReactLink}
              to={"/crianca/" + id}
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          ) : (
            <Link
              wordBreak={"break-all"}
              title={name}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.servicoAcolhimento?.idPessoaJuridica,
                  props?.row?.original?.movimentacoes[0]?.idMovimento,
                )
              }
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          )
        ) : ultimaMovimentacao?.riscoVidaMotivoSituacao === "N" ||
          !ultimaMovimentacao?.riscoVidaMotivoSituacao ? (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                F
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: "Idade",
      accessor: "idadeCrianca",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
    {
      Header: "Filiação",
      accessor: "pais",
      sortType: (rowA, rowB, id, desc) => {
        const filiacoesA = rowA?.original?.filiacoes?.length
          ? rowA.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        const filiacoesB = rowB?.original?.filiacoes?.length
          ? rowB.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        return filiacoesA.localeCompare(filiacoesB, "pt-BR");
      },
      Cell: (props) => {
        return props?.value
          .sort((a, b) =>
            a.descricaoTipoRelacionamento.localeCompare(
              b.descricaoTipoRelacionamento,
            ),
          )
          .map((filiacao, index) => {
            return (
              <React.Fragment key={index}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {filiacao?.nome}{" "}
                  <Text as="span" textTransform="capitalize">
                    ({filiacao?.descricaoTipoRelacionamento.toLowerCase()})
                  </Text>
                </span>
                {props.value.length - 1 !== index && <br />}
              </React.Fragment>
            );
          });
      },
    },
    {
      Header: "Pendências",
      accessor: "descricaoTipoPendencia",
      Cell: (props) => {
        const pendencia = props?.value;
        const idAba = props?.row?.original?.idAba;
        const idTipoPendencia = props?.row?.original?.idTipoPendencia;
        const idCrianca = props?.row?.original?.idCrianca;
        const idPJ = props?.row?.original?.idPessoaJuridica;

        return (
          <Link
            onClick={() => {
              handleVerifyRedirectPendencia(
                idAba,
                idTipoPendencia,
                history,
                idCrianca,
                true,
                roleKeycloack,
                user,
                idPJ,
              );
            }}
          >
            {pendencia ? pendencia : ""}
          </Link>
        );
      },
    },
    {
      Header: "Aba",
      accessor: "nomeAba",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
  ];

  const riscoAlert = (id, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  const getExportarExecel = async () => {
    const tempObj = JSON.parse(
      sessionStorage.getItem("table-relatorio-pendencia"),
    );

    const valuesToSend = {
      dataReferencia: storage?.dataReferencia
        ? formatDateToISOWithNow(storage.dataReferencia)
        : "",
      municipioId: storage?.municipioId?.id ? storage?.municipioId?.id : 0,
      promocaoId: storage?.promocaoId?.id ? storage?.promocaoId?.id : 0,
      servicoAtendimentoId: storage?.servicoAtendimentoId?.id
        ? storage?.servicoAtendimentoId?.id
        : 0,
      tipoRelatorio: tipoRelatorio ? tipoRelatorio : "",
      sortField: tempObj ? tempObj[0]?.id : "nomeMunicipio",
      sortType: tempObj ? (tempObj[0]?.desc ? "DESC" : "ASC") : "ASC",
    };

    try {
      setLoadingExcel(true);
      await RelatorioService.getExecelListaRelatorio(valuesToSend);
      Swal.fire({
        title: "Em processamento",
        html: `<div style="text-align: center;">Este relatório está sendo processado em segundo plano. <br /> Para acompanhar, verifique a sua fila de processamento localizado no <br /> menu lateral do sistema.</div>`,
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Ir para Fila de Processamento",
        cancelButtonText: "Fechar",
        width: "600px",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/fila-processamento");
        }
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExcel(false);
    }
  };

  const [data, setData] = useState();
  const isDisabled = loadingExcel || !data?.content?.length;

  return roleKeycloack &&
    roleKeycloack?.includes(dashboardFunc.relatorioPendenciasExportar) ? (
    <Flex
      flex={1}
      flexDir="column"
      px={["5px", "32px"]}
      pb="20px"
      alignItems="center"
      overflow="auto"
    >
      <Group
        mt={1}
        title={"Relatório de Pendências"}
        opcoes={true}
        voltar={true}
        dividerFalse={true}
      >
        <>
          <Box mt={4}>
            <FiltersRelatorioPendencia
              data={data}
              setData={setData}
              setLoading={setLoading}
              loading={loading}
              entidade="relatorio-pendencia"
              roleKeycloack={roleKeycloack}
              atualizarDadosTabela={atualizarDadosTabela}
              setAtualizarDadosTabela={setAtualizarDadosTabela}
              setTipoRelatorio={setTipoRelatorio}
            />
          </Box>

          {!loading ? (
            data && (
              <>
                <Flex
                  mt={4}
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                >
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    gap={2}
                  >
                    <Box
                      w="3"
                      h="3"
                      bg="#169499"
                      borderRadius="full"
                      border="1px"
                      color="#169499"
                    />
                    <Text>Data da geração: {dataFormatada}</Text>
                  </Flex>
                  {loading ? (
                    <Spinner size="sm" />
                  ) : (
                    <Flex
                      alignItems="center"
                      gap={2}
                      cursor={isDisabled ? "not-allowed" : "pointer"}
                      pointerEvents={isDisabled ? "none" : "auto"}
                      onClick={() => !isDisabled && getExportarExecel()}
                    >
                      <Flex
                        bg={isDisabled ? "#A9A9A9" : "#006400"}
                        rounded="full"
                        p={1}
                      >
                        <RiFileExcel2Line color="white" />
                      </Flex>

                      <Text
                        as="b"
                        color={isDisabled ? "#A9A9A9" : "#006400"}
                        fontSize={"md"}
                      >
                        Exportar em Excel
                      </Text>
                    </Flex>
                  )}
                </Flex>

                <Flex
                  bgColor={"#16949933"}
                  mt={4}
                  px="20px"
                  py="16px"
                  border={"solid 1px #DEE2E6"}
                  borderTop={"solid 3px #169499"}
                >
                  <Relatorio />

                  <Flex flexDir={"column"} ml={2} gap={2}>
                    <Text
                      color={"#575553"}
                      fontSize="16px"
                      lineHeight="21.6px"
                      fontWeight="bold"
                    >
                      Universo das Pendências:{" "}
                      {storage?.tipoRelatorio?.labelText ?? ""}
                    </Text>
                    <Text
                      color={"#1A203D"}
                      fontWeight="500"
                      fontSize="14px"
                      lineHeight="21.6px"
                    >
                      Município:{" "}
                      {storage?.servicoAtendimentoId &&
                      !storage?.promocaoId &&
                      !storage?.municipioId
                        ? storage?.servicoAtendimentoId?.municipio?.nome
                        : storage?.promocaoId &&
                            !storage?.servicoAtendimentoId &&
                            !storage?.municipioId
                          ? storage?.promocaoId?.municipios[0]?.nome
                          : storage?.municipioId?.nome &&
                              storage?.municipioId?.id
                            ? storage?.municipioId?.nome
                            : "Todos"}
                    </Text>

                    <Text
                      color={"#1A203D"}
                      fontWeight="500"
                      fontSize="14px"
                      lineHeight="21.6px"
                    >
                      Serviço de Acolhimento:{" "}
                      {storage?.servicoAtendimentoId?.nomeFantasia ?? "Todos"}
                    </Text>

                    <Text
                      color={"#1A203D"}
                      fontWeight="500"
                      fontSize="14px"
                      lineHeight="21.6px"
                    >
                      Promotoria:{" "}
                      {storage?.servicoAtendimentoId &&
                      !storage?.promocaoId &&
                      !storage?.municipioId
                        ? storage?.servicoAtendimentoId?.promotoria?.nome
                        : (storage?.promocaoId?.nome ?? "Todos")}
                    </Text>
                    <Text
                      color={"#1A203D"}
                      fontWeight="500"
                      fontSize="14px"
                      lineHeight="21.6px"
                    >
                      Data de Referência:{" "}
                      {storage?.dataReferencia || dataFormatadaDate}
                    </Text>
                  </Flex>
                </Flex>
                <TableRelatorioPendencia
                  data={data.content}
                  columns={
                    tipoRelatorio ===
                    "RELATORIO_PENDENCIAS_SERVICOS_ACOLHIMENTO"
                      ? columnsServico
                      : columns
                  }
                  isOpenNovoAcolhimento={isOpenNovoAcolhimento}
                  onOpenNovoAcolhimento={onOpenNovoAcolhimento}
                  onCloseNovoAcolhimento={onCloseNovoAcolhimento}
                  entidade="relatorio-pendencia"
                  atualizarDadosTabela={atualizarDadosTabela}
                  setAtualizarDadosTabela={setAtualizarDadosTabela}
                  roleKeycloack={roleKeycloack}
                  user={user}
                  setData={setData}
                  idPJ={idPJ}
                />
              </>
            )
          ) : (
            <Box mt={4}>
              <LoadingSpinner />
            </Box>
          )}
        </>
      </Group>
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
